// Estilos compartidos chiquitos, para no repetirlos en cada pantalla.
import styled from 'styled-components';

export const H2 = styled.h2`
  font-size: 1.25rem;
  margin: 20px 0 10px;
`;

export const Muted = styled.div`
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 0.92rem;
  line-height: 1.5;
`;

export const Pill = styled.span`
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: 999px;
  background: ${({ theme }) => theme.colors.surfaceAlt};
  color: ${({ theme }) => theme.colors.textMuted};
`;

export const BackLink = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.accent};
  padding: 4px 0 12px;
  font-weight: 700;
`;
